import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== cf) { toast.error("Passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      await refresh();          // update password_must_change=false in auth context
      toast.success("Password changed");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Change failed");
    } finally { setSaving(false); }
  };

  return (
    <AppLayout title="Change password">
      <div className="max-w-md mx-auto miro-card p-8 mt-8">
        <div className="w-11 h-11 rounded-lg bg-[var(--miro-navy)] text-white flex items-center justify-center mb-4">
          <KeyRound size={20}/>
        </div>
        <div className="miro-overline">Security</div>
        <h1 className="font-display font-black text-2xl text-[var(--miro-navy)] mt-1">Change your password</h1>
        <p className="text-sm text-[var(--miro-text-secondary)] mt-2">
          Passwords must be at least 8 characters and mix upper, lower, digit and symbol (3 of 4).
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="cur">Current password</Label>
            <Input id="cur" data-testid="change-pwd-current" type="password" value={cur} onChange={(e)=>setCur(e.target.value)} required className="mt-1"/>
          </div>
          <div>
            <Label htmlFor="nw">New password</Label>
            <Input id="nw" data-testid="change-pwd-new" type="password" value={nw} onChange={(e)=>setNw(e.target.value)} required className="mt-1"/>
          </div>
          <div>
            <Label htmlFor="cf">Confirm new password</Label>
            <Input id="cf" data-testid="change-pwd-confirm" type="password" value={cf} onChange={(e)=>setCf(e.target.value)} required className="mt-1"/>
          </div>
          <Button data-testid="change-pwd-submit" type="submit" disabled={saving}
                  className="w-full h-11" style={{ background: "var(--miro-navy)" }}>
            {saving ? "Saving…" : "Update password"}
          </Button>
        </form>
      </div>
    </AppLayout>
  );
}
